<template>
    <div class="view-body">
        <div class="view-body-content">
            <div class="view-body-content-head">
                <span class="view-body-content-head-icon"
                    :class="{
                        'view-body-content-head-icon-blue': detail.businessProperty === 3,
                        'view-body-content-head-icon-red': detail.businessProperty === 2,
                        'view-body-content-head-icon-yellow': detail.businessProperty === 4
                    }">{{ propertyType }}</span>
                <span class="view-body-content-head-title" @click="$router.push('/bfMerchantsShop?businessNumber='+detail.businessNumber+'&&businessProperty='+detail.businessProperty)">{{ detail.businessName }}</span>
            </div>
            <div class="view-body-content-shopping" @click="$router.push(`/goodsDetail/${item.orderDetailsProductId}`)" v-for="(item,key) in detail.details" :key="key">
                <div class="view-body-content-shoppingImg">
                    <img :src="getFirstImg(item.orderDetailsProductImg)" alt="">
                </div>
                <div class="view-body-content-shoppingP">
                    <div class="view-body-content-shoppingP1">
                        <p>{{ item.orderDetailsProductName }}</p>
                        <p>￥{{ item.orderDetailsPreferentialPrice }}</p>
                    </div>
                    <div class="view-body-content-shoppingP2 clearfix">
                        <p style="color: #999">x{{ item.orderDetailsProductNumber }}</p>
                        <p v-if="item.needCredit !== 0">￥{{ item.creditProductPrice || 0 }}+{{ item.needCredit || 0 }}积分</p>
                    </div>
                </div>
            </div>
            <div class="view-body-content-bottom">
                <p class="view-body-content-bottomFee">
                    配送费<span>￥{{ detail.sendMoney }}</span>
                </p>
                <p class="view-body-content-bottomFee view-body-content-color" v-if="detail.businessProperty == 2||(detail.businessProperty == 3&&detail.jfdkNum==0)">
                    满减优惠<span>-￥{{ detail.discountMoney }}</span>
                </p>
                <p class="view-body-content-bottomFee view-body-content-color" v-if="detail.businessProperty !== 2&&detail.businessProperty !== 4&&detail.jfdkNum>0">
                    积分抵扣<span>-￥{{ detail.discountMoney }}</span>
                </p>
            </div>
            <div class="view-body-content-footer">
                <span>已优惠</span>
                <span class="content-footer-red">￥{{detail.discountMoney}}</span>
                <span>合计￥</span>
                <span class="content-footer-big">{{detail.orderFactMoney}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import baseUrl from '@/config/baseUrl';
export default {
    props: {
        detail: Object
    },
    data() {
        return {
            orderDetail: {
                businessInfo: {}
            },
            orderParams: {}
        };
    },
    computed: {
        propertyType() {
            if(this.detail.businessProperty === 2) {
                return '缤纷';
            }else if(this.detail.businessProperty === 3) {
                return '自营';
            }else if(this.detail.businessProperty === 4) {
                return '周边';
            }
            return '';
        }
    },
    methods: {
        getFirstImg(s) {
            let arr = s.split(',');
            return arr.length ? baseUrl.imgUrl + arr[0] : '';
        }
    }
};
</script>
<style lang="scss" scoped>
.view-body {
    padding: 9px 10px;

    .view-body-content{
        background: #fff;
        border-radius: 5px;
        .view-body-content-head{
            padding: 15px;
            .view-body-content-head-icon{
                display: inline-block;
                text-align: center;
                width:39px;
                border-radius:16px;
                font-size:12px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height: 16px;
            }
            .view-body-content-head-icon-blue {
                background-color: #2D95FE;
            }
            .view-body-content-head-icon-red {
                background-color: #EB5435;
            }
            .view-body-content-head-icon-yellow {
                background-color: #ED863F;
            }
            .view-body-content-head-title{
                display: inline-block;
                margin-left: 10px;
                font-size:15px;
                font-family:PingFang SC;
                font-weight:bold;
                color:#333;
            }
        }
        .view-body-content-shopping{
            border-bottom: 10px solid #fff;
            padding: 15px;
            display: flex;
            background: #F2F2F2;
            .view-body-content-shoppingImg{
                flex: 1;
                img{
                    width:50px;
                    height:50px;
                }
            }
            .view-body-content-shoppingP{
                flex: 6;
                margin-left: 10px;
                .view-body-content-shoppingP1{
                    font-size:15px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:#333;
                    display: flex;
                    min-width: 0;
                    margin-bottom: 10px;
                    p:first-child{
                        flex: 5;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                    }
                    p:last-child{
                        flex: 1;
                        text-align: right;
                    }
                }
                .view-body-content-shoppingP2{
                    font-size:15px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:#999;
                    p:last-child{
                        color:#333;
                        float: right;
                    }
                    p:first-child{
                        float: left;
                    }
                }
            }
        }
        .view-body-content-bottom{
            padding: 0 15px;
            .view-body-content-bottomFee{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:#333333;
                line-height:40px;
                span{
                    font-weight: bold;
                    float: right;
                }
            }
            .view-body-content-color span {
                color: #EB5435;
            }
            .view-body-content-bottomIntegral{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:#333333;
                line-height:30px;
                .van-switch{
                    float: right;
                    margin-top: 6px;
                    font-size:15px !important;
                }
            }
            .view-body-content-bottomNum{
                font-size:15px;
                font-family:PingFang SC;
                font-weight:500;
                color:#909090;
                line-height:30px;
                padding-bottom: 10px;
                span{
                    color: #FF3F3F;
                }
            }
        }
        .view-body-content-footer {
            margin: 0 15px;
            padding: 10px 0;
            font-size: 15px;
            text-align: right;
            border-top: 1px solid #E3E3E3;

            .content-footer-red {
                font-weight: bold;
                color: #E75A4B;
            }
            .content-footer-big {
                font-size: 24px;
            }
        }
    }
}
</style>